import { common } from "../../copy/sq";

export function Skeleton({ className = "" }: { className?: string }) {
  return <div className={`animate-pulse rounded-md bg-ink-100 ${className}`} aria-hidden="true" />;
}

export function SkeletonCard() {
  return (
    <div className="rounded-xl2 border border-ink-100 bg-white p-5 shadow-card">
      <Skeleton className="mb-3 h-4 w-1/3" />
      <Skeleton className="mb-2 h-3 w-full" />
      <Skeleton className="h-3 w-5/6" />
    </div>
  );
}

export function SkeletonScreen({ cards = 3 }: { cards?: number }) {
  return (
    <div className="grid gap-4" role="status" aria-label={common.loadingLabel}>
      {Array.from({ length: cards }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
      <span className="sr-only">{common.loadingLabel}…</span>
    </div>
  );
}
